/**
 * Website SPA — Entry Point
 * ─────────────────────────
 * Bootstraps the public-facing website renderer.
 * Mounts on #website-app in the PHP shell page.
 */
import Vue from 'vue';
import App from './App.vue';
import SiteBlockRenderer from './SiteBlockRenderer.vue';
import SiteColumnsLayout from './SiteColumnsLayout.vue';
import AccessibilityWidget from './AccessibilityWidget.vue';

// Register globally to break the circular dependency between
// SiteBlockRenderer ↔ SiteColumnsLayout (block renderer must be
// able to render columns, and columns must render child blocks).
Vue.component('SiteBlockRenderer', SiteBlockRenderer);
Vue.component('SiteColumnsLayout', SiteColumnsLayout);
Vue.component('AccessibilityWidget', AccessibilityWidget);

new Vue({
	el: '#website-app',
	render: function (h) { return h(App); }
});
